<div id="w3l-appointment" style="width: 1000px;">
  <section class="appointment-section section-gap" >
    <div class="wrapper">
      <div class="d-grid doctor-appointment" >
        <div class="appointment-form" >
          
          <form action="#" method="post"  >
            <div class="fields-grid" >
              <div class="styled-input" >
                <div class="appointment-form-field">
                  <label style="width: 10%;">P.O. Serial</label>
                  <span class="fa fa-search" aria-hidden="true" style="cursor: grab;"(click)="openDialogOrder()"></span>
                  <input type="text" name="PreparationOrderId" placeholder="Preparation Order Id" style="width: 20%;"required [(ngModel)]="documentCode" (change)="retrivePreHD()">
                  <label style="width: 2%;"></label>
                  <label style="width: 15%;">Previous P.O</label>
                  <span class="fa fa-search" aria-hidden="true" (click)="openDialogOrderCopy()"></span>
                  <input type="text" name="PreparationOrderIdCpy" placeholder="From P.O. Number" style="width: 20%;" required [(ngModel)]="documentCodeCopy">
                  <button name="copy" placeholder="0" class="theme-button btn fa fa-files-o" style="width: 15px;height: 100%;font-size: medium;cursor:copy;" required (click)="retrivePreHDCopy()">  Copy</button>
                </div>
              </div>
              <div class="styled-input">
                <div class="appointment-form-field">
                  <label style="width: 10%;">P.O. Date</label>
                  <span class="fa fa-calendar" aria-hidden="true"></span>
                  <input type="date" name="PreparationOrderDate" required style="width: 20%;" [(ngModel)]="docDate">
                  <label style="width: 2%;"></label>
                  <label style="width: 15%;">Location</label>
                  <span class="fa fa-clone" aria-hidden="true"></span>

                  <select id="PatientStatus" name="PatientStatus" [(ngModel)]="pstatus" style="width: 33.5%;background-color:  rgb(187, 203, 238);"  required>
                    <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
                  </select>


                </div>
              </div>
              <!------ Doctores ------->
              <div class="styled-input">


                <div class="appointment-form-field">
                  <label style="width: 10%;">Doctor</label>
                  <span class="fa fa-headphones" aria-hidden="true"></span>
                  <select id="doctor" name="doctor" required="" [(ngModel)]="docCode" [value]="docName" style="width: 20%;">
                    <option value="{{doc.docCode}}" *ngFor="let doc of doctorsList; let i = index">{{doc.docName}}
                    </option>
                  </select>
                  <label style="width: 2%;"></label>
                  <label style="width: 15%;">Pharmacist</label>
                  <span class="	fa fa-user-md" aria-hidden="true"></span>
                  <select id="doctor" name="doctorPharm" required="" [(ngModel)]="docCode1" [value]="docName1" style="width: 34%;" (change)="submitPreparationHD()">
                    <option value="{{doc.docCode}}" *ngFor="let doc of doctorsLis1; let i = index">{{doc.docName}}
                    </option>
                  </select>
                </div>

              </div>
              <!------ Patient Data ------->
                <div class="appointment-form-field">
                  <label style="width: 10%;">Patient ID</label>
                  <span type="submit" class="fa fa-search" (click)="openDialog()" style="cursor: grab;"></span>
                  <input type="text" name="patientId" placeholder="Pat. Code" style="width: 20%;" required [(ngModel)]="patientCode" (change)="retrievePatient()">
                  <input type="text" name="patientName" disabled style="width: 70%;background-color:  rgb(187, 203, 238);" [(ngModel)]="patientFName">

                </div>

              <div class="styled-input" style="background-color: rgb(187, 203, 238);width: 100%;border-style: groove;border-color:rgb(187, 203, 238);border-radius: 3%;">

                <label style="width: 5%;"></label>
                <label style="width: 15%;">Birth Date:</label>
                <input type="date" name="BirhtDate" required style="width: 20%;border-style: none;background-color:  rgb(187, 203, 238);font-size: x-large;"[(ngModel)]="birthDate">
                <label style="width: 5%;"></label>
                <label style="width: 5%;">Age :</label>
                <input type="text" name="age" placeholder="0" required disabled style="width: 5%;background-color:  rgb(187, 203, 238);font-size: larger;border-style: none;" [(ngModel)]="paAge">
                <label> Year</label>
                <label style="width: 5%;"></label>
                <label style="width: 10%;">Gender</label>
                <span class="fa fa-user-plus" aria-hidden="true"></span>
                <input type="text" name="Gender" required disabled style="width: 10%;background-color: rgb(187, 203, 238);border-style: none;font-size: larger;" [(ngModel)]="gender">
              <div>
                <label style="width: 5%;"></label>
                <label style="width: 15%;">Date of first Visit:</label>
                <input type="date" name="dateEntry1" required style="width: 20%;border-style: none;background-color:  rgb(187, 203, 238);font-size: x-large;"[(ngModel)]="dateEntry1">
                <label style="width: 5%;"></label>
                <label style="width: 15%;">Cancer Type :</label>
                <span class="fa fa-universal-access" aria-hidden="true"></span>
                <select id="CancerType" name="CancerType" style="width: 35%;background-color:  rgb(187, 203, 238);border-style: none;font-size: larger;"
                    required="" [(ngModel)]="cancerID" [value]="cancerID">
                    <option value="{{Canc.cancerID}}" *ngFor="let Canc of cancerlist; let i = index">{{Canc.cancerName}}
                    </option>
                  </select>
              </div>
              <!-- Pathology Diganosis -->
              <!-- <div>
                <label style="width: 5%;"></label>
                <label style="width: 15%;">Pathology:</label>
                <span class="fa fa-medkit" aria-hidden="true"></span>
                  <select id="Pathology1" name="Pathology1" style="width: 20%;border-style: none;background-color:  rgb(187, 203, 238);font-size: large;"
                    [(ngModel)]="pathology" [value]="pathology" required>
                    <option value="1">IDC</option>
                    <option value="2">Adenocarcinoma</option>
                    <option value="3">IDC</option>
                    <option value="5">GIST</option>
                    <option value="6">liomyosarcoma</option>
                  </select>
                <label style="width: 3%;"></label>
                <label style="width: 15%;">Diagnosis :</label>
                <span class="fa fa-sliders" aria-hidden="true"></span>
                  <input type="text" name="Diagnosis" style="width: 35%;border-style: none;background-color:  rgb(187, 203, 238);font-size:large;" required [(ngModel)]="diganosis">

              </div> -->
            </div>
<!--
              <div class="styled-input">

                <div class="appointment-form-field">
                  <label style="width: 10%;">CBC</label>
                  <span class="fa fa-bed" aria-hidden="true"></span>
                  <input type="date" name="cbcDate1" id="cbcDate1" required style="width: 15%;" [(ngModel)]="cBcDate">

                  <a (click)="openDialogC()" class="fa fa-search"style="cursor: zoom-in; font-size:1.6ch;width: 15%;color: darkblue;">Select CBC</a>
                  <label style="width: 15%;">Patient Status</label>
                  <span class="fa fa-clone" aria-hidden="true"></span>
                  <select id="PatientStatus" name="PatientStatus" style="width: 26%;background-color:  rgb(187, 203, 238);" [(ngModel)]="pstatus" [value]="pstatus"
                    required>
                    <option value="Adjuvant">Adjuvant </option>
                    <option value="Neoadjuvant">Neoadjuvant</option>
                    <option value="Metastatic">Metastatic</option>

                  </select>

                </div>
              </div> -->
              <div class="styled-input" style="background-color: rgb(187, 203, 238);width: 100% !important;border-style: groove;border-color:rgb(199, 219, 250) ;border-radius: 3%;">




                  <div class="appointment-form-field" style="width: 99%;background-color: rgb(187, 203, 238);">

                  <label style="width: 12%;font-size: 80%;background-color: rgb(187, 203, 238);">Pulse(b.p.m)</label>
                  <input type="text" name="puls" id="puls" required placeholder="00" style="width: 8%;font-size:1.5ch;" [(ngModel)]="prHdPulse">
                  <label style="width: 1%;"></label>

                  <label style="width: 3%;font-size: 80%;background-color: rgb(187, 203, 238);">B.P</label>
                  <input type="text" name="BP" placeholder="000/000" style="width: 10%; font-size:1.5ch;"[(ngModel)]="prHdB_P">
                  <label style="width: 1%;"></label>

                  <label style="width: 8%;font-size: 80%;background-color: rgb(187, 203, 238);">Temp(cº)</label>
                  <input type="text" name="temp" value="37" placeholder="00.00" required="" style="width: 8%;font-size:1.5ch;" [(ngModel)]="prHdTemp">
                  <label style="width: 1%;"></label>

                  <label style="width: 10%;font-size: 80%;background-color: rgb(187, 203, 238);">RBG(mg\dl)</label>
                  <input type="text" name="cbg" placeholder="00.00" required="" style="width: 8%;font-size:1.5ch;" [(ngModel)]="prHdCBG">
                  <label style="width: 1%;"></label>

                  <label style="width: 10%;font-size: 80%;background-color: rgb(187, 203, 238);">Weight(Kg)</label>
                  <input type="text" name="weight" placeholder="00.00" required="" style="width: 8%;font-size:1.5ch;" [(ngModel)]="prHdWeight">
                  <label style="width: 1%;"></label>

                  <label style="width: 10%;font-size: 80%;background-color: rgb(187, 203, 238);">Height(cm)</label>
                  <input type="text" name="height" placeholder="00.00" required="" style="width: 8%;font-size:1.5ch;"   [(ngModel)]="prHdHeight">
                  </div>
                  <div class="appointment-form-field" style="width: 99%;background-color: rgb(187, 203, 238);">

                    <label style="width: 11%;font-size: 80%;background-color: rgb(187, 203, 238);">Nursing Notes</label>
                    <input type="text" name="nunotes" id="nunotes" required  style="width: 100%;font-size:1.5ch;" [(ngModel)]="nursingnotes">

                  </div>

              </div>
                <!-- <app-doctor-observation (PaShared)="RecShared($event)" hidden="true"></app-doctor-observation> -->

              <div class="styled-input">

                <div class="styled-input">
                  <label>▀ N.B :         Bonet  : </label>
                  <input type="radio" name="DStatus" value="Yes" [(ngModel)]="prHdBonet"> Yes    
                  <input type="radio" name="DStatus" value="No" [(ngModel)]="prHdBonet" checked> No
                </div>

                <div class="appointment-form-field" style="width: 92%;">
                  <label style="width: 15%;">Adj.B.W(kg)</label>
                  <span class="fa fa-hotel" aria-hidden="true"></span>
                  <input type="text" name="prHdAdj" style="width: 20%;" [(ngModel)]="prHdAdj" placeholder="00.00" required=""    style="width: 25%;font-size:1.1ch;">
                  <label  style="width: 2%;"></label>

                  <label style="width: 10%;">B.SA(m2)</label>
                  <span class="fa fa-calendar-check-o" aria-hidden="true"></span>
                  <input type="text" name="prHdBsa"  [(ngModel)]="prHdBsa" placeholder="00.00" required=""  style="width: 20%;font-size:1.1ch;">
                  <label  style="width: 2%;"></label>
                  <label style="width: 10%;">Cycle/Week</label>
                  <span class="fa fa-calendar-check-o" aria-hidden="true"></span>
                  <input type="text" name="days1" [(ngModel)]="prHdCycle" placeholder="00.00" required=""  style="width: 20%;font-size:1.1ch;">
                  <label  style="width: 5%;"></label>
                  <label style="width: 10%;">Day</label>
                  <span class="fa fa-hotel" aria-hidden="true"></span>
                  <input type="text" name="Day" [(ngModel)]="prHdDays" placeholder="00.00" required="" style="width: 22%;font-size:1.1ch;">
                  <label style="width: 2%;"></label>

        </div>
<BR><BR>
                <div class="appointment-form-field" style="width: 92%;">
                  <label  style="width: 15%;">Dose Modification</label>
                  <span class="fa fa-percent" aria-hidden="true"></span>
                  <input type="text" [(ngModel)]="prHdModifPerc" name="modificationPr" maxlength="6ch" style="width: 20%;font-size:1.1ch;" placeholder="00">
                  <label style="width: 11.5%;">Why</label>

                  <span class="fa fa-pencil-square-o" aria-hidden="true" style="height: 200%;"></span>
                  <textarea rows="5" cols="60" name="whay" [(ngModel)]="prHdWhay" class="appointment-form-field"  style="height: 200%;" maxlength="150ch" placeholder="Details... "> </textarea><br>
                </div>
                <BR>
              </div>

              <!---------- ********** Protocols *****--------->
              <div class="styled-input">
                <div class="appointment-form-field" style="width: 92%;">
                  <label  style="width: 11%;">Protocol :</label>
                  <span type="submit" class="fa fa-search" (click)="mesgReload()" style="cursor: grab;"></span>
                  <input type="text" name="protocolId" placeholder="Protocol ID" style="width: 20%;"  [(ngModel)]="prHdCode" required disabled>
                  <input type="text" name="ProtocolName" disabled style="width: 68%;" [(ngModel)]="prHdName">
                </div>

              </div>
              <!---------- ********** Pre-Medication Treatment table *****--------->
              <div>
                <label class="appointment-form-field"
                  style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Pre-Medication  
                </label>
                <table>
                <thead>
                    <tr>
                      <!-- <th style="background-color:  rgb(70, 70, 247);color: white;width: 60px;height: 5%;">Category</th> -->
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 200px;height: 25%;">Drug</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 40px;height: 5%;">Dose</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 40px;height: 15%;">Unit</th>
                      <!-- <th style="background-color:  rgb(70, 70, 247);color: white;width: 40px;height: 5%;">Final Dose</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 40px;height: 15%;">FD Unit</th> -->
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 160px;height: 30%;">Duration</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 40px;height: 30%;">Step</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 200px;height: 35%;">Solution</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 35x;height: 35%;">Dispensed</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 35px;height: 35%;">Saved</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 60px;height: 13%;">Select</th>
                    </tr>
                </thead>
                  <tbody>

                    <tr *ngFor="let pro of prepList; let i = index" style="height: 50%;">
                      <!-- <td data-column="Patient ID" style="height: 50%;">{{pro.categoryName}}</td> -->
                      <td data-column="Patient Name" style="height: 50%;">{{pro.drgName}}</td>
                      <td data-column="Patient QTY" style="height: 50%;">{{pro.perpDaose}}</td>
                      <td data-column="Patient Unit11" style="height: 50%;">{{pro.unName}}</td>
                      <!-- <td data-column="Patient Dose" style="height: 50%;">{{pro.prepFD}}</td>
                      <td data-column="Patient Unit22" style="height: 50%;">{{pro.unName1}}</td> -->
                      <td data-column="Patient Duration" style="height: 50%;">{{pro.prepDuration}}</td>
                      <td data-column="Patient step" style="height: 50%;">{{pro.prepImportant}}</td>
                      <td data-column="Patient solution" style="height: 50%;">{{pro.preSolution}}</td>
                      <td data-column="Patient solution" style="height: 50%;">{{pro.prepdisp}}</td>
                      <td data-column="Patient solution" style="height: 50%;">{{pro.prepsaved}}</td>
                      <td data-column="Dos" style="height: 50%;">

                        <button name="BDrug" placeholder="0" style="width: 100%;height: 100%;border-radius: 10%;color: green;font-weight: bold;" required
                          (click)="SelectPreMedication(pro)"  [disabled]="disablepharnacy">Select</button>

                      </td>
                    </tr>
                  </tbody>
                </table>

                <button name="Del" placeholder="0" class="fa fa-plus" style="width: 200px; height: 50px;" required (click)="AddNewLine1()" [disabled]="disablepharnacy">Add New Line</button>
                <!-- </div> -->
              </div>

              <BR>
              <BR>
              <!---------- ********** Chemotherapy Treatment table *****--------->

              <div>
                <label class="appointment-form-field"
                  style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Prepared Treatment  
                </label>
                <table>
                <thead>
                    <tr>
                      <!-- <th style="background-color:  rgb(70, 70, 247);color: white;width: 102px;height: 50%;">Category</th> -->
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 200px;height: 100%;">Drug</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 40px;height: 5%;">Dose</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 40px;height: 15%;">Unit</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 40px;height: 5%;">Final Dose</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 40px;height: 15%;">FD Unit</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 160px;height: 30%;">Duration
                      </th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 40px;height: 30%;">Step</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 200px;height: 30%;">Solution
                      </th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 35px;height: 35%;">Dispensed </th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 35px;height: 35%;">Saved</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 60px;height: 80%;">Select</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cho of prepListChemo; let i = index" style="height: 50%;">
                      <!-- <td data-column="Patient ID1" style="height: 5%;">{{cho.categoryName}}</td> -->
                      <td data-column="Patient Name1" style="height: 50%;">{{cho.drgName}}</td>
                      <td data-column="Patient qty1" style="height: 50%;">{{cho.perpDaose}}</td>
                      <td data-column="Patient unit1" style="height: 50%;">{{cho.unName}}</td>
                      <td data-column="Patient Fdose1" style="height: 50%;">{{cho.prepFD}}</td>
                      <td data-column="Patient unit2" style="height: 50%;">{{cho.unName1}}</td>
                      <td data-column="Patient Duration" style="height: 50%;">{{cho.prepDuration}}</td>
                      <td data-column="Patient step" style="height: 50%;">{{cho.prepImportant}}</td>
                      <td data-column="Patient solution1" style="height: 50%;">{{cho.preSolution}}</td>
                      <td data-column="Patient solution" style="height: 50%;">{{cho.prepdisp}}</td>
                      <td data-column="Patient solution" style="height: 50%;">{{cho.prepsaved}}</td>
                      <td data-column="Dos" style="height: 50%;">
                      <button name="Drug" placeholder="0" style="width: 100%;height: 100%;border-radius: 10%;color: green;font-weight: bold;" required (click)="SelectChemoLine(cho)"  [disabled]="disablepharnacy">Select</button>

                      </td>
                    </tr>

                  </tbody>
                </table>
                <div class="appointment-form-field" style="width: 850px;border-collapse: collapse;">
                  <button name="Del" placeholder="0" class="fa fa-plus" style="width: 175px; height: 50px;" required (click)="AddNewLine2()"  [disabled]="disablepharnacy">Add New Line</button>
                </div>
              </div>
              <!---------- *********************************************--------->
              <BR>
              <BR>
              <!---------- ********** Supportive Treatment table *****--------->
              <div>
                <label class="appointment-form-field"
                  style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Discharge Medications   </label>
                <table>
                  <thead>
                    <tr>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 45%;">Drug</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Unit</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;">Dos</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 20%;">Frequency</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 100%;">Select</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let sup of prepListSupp; let i = index" style="height: 50%;">

                      <td data-column="drug Name" style="height: 50%;">{{sup.drgName}}</td>
                      <td data-column="unit Name" style="height: 40%;">{{sup.unName}}</td>
                      <td data-column="dose Name" style="height: 50%;">{{sup.perpDaose}}</td>
                      <td data-column="rote" style="height: 50%;">{{sup.prepRout}}</td>

                      <button name="Drug4" placeholder="0" style="width: 100%;height: 37px;color: green;font-weight: bold;" required
                        (click)="SelectSupLine(sup)"  [disabled]="disablepharnacy">Select</button>
                    </tr>
                  </tbody>
                </table>
                <button name="Del11" placeholder="0" class="fa fa-plus" style="width: 22.5%; height: 50px;" required (click)="AddNewLine3()"  [disabled]="disablepharnacy">  Add New Line</button>
                <button name="prescription" placeholder="0" class="fa fa-print" style="width: 22.5%; height: 50px;" required (click)="Prescription()"  [disabled]="disablepharnacy">  Prescription</button>

              </div>
              <!---------- *********** Current Medication Interaction****************--------->
              <BR>
              <BR>
                <div class="styled-input">
                  <label>Notes</label>
                  <BR>
                  <BR>
                  <div class="appointment-form-field">
                    <span class="fa fa-university" aria-hidden="true" style="height: 200%;"></span>
                    <textarea rows="5" cols="60" name="description" class="appointment-form-field" style="height: 200%;" maxlength="500ch" placeholder="Enter details here... " [(ngModel)]="prNotes"> </textarea><br>
                  </div>
                </div>
              <div class="styled-input">
                <label>Nutrition Notes</label>
                <BR>
                <BR>
                <div class="appointment-form-field">
                  <span class="fa fa-university" aria-hidden="true" style="height: 200%;"></span>
                  <textarea rows="5" cols="60" name="prnextlab" class="appointment-form-field" style="height: 200%;"  placeholder="Enter details here... " [(ngModel)]="prnextlab"> </textarea><br>
                </div>
              </div>

              <div class="styled-input">
                <label>Next appointment for</label>
                <BR>
                <BR>
                <div class="appointment-form-field">
                  <span class="fa fa-university" aria-hidden="true" style="height: 200%;"></span>
                  <textarea rows="5" cols="60" name="fornext" class="appointment-form-field" style="height: 200%;" maxlength="500ch" placeholder="Enter details here... " [(ngModel)]="prepYear"> </textarea><br>
                </div>
              </div>
              <div style="text-align: center; ">
                <button type="button" class="theme-button btn" name="submit"  (click)="OpenDialogCurrentMedication()"  style="background-color: rgb(0, 0, 118);color: white;" >Current Non-cancer Medication - Drug-Drug Interactions</button>
               </div>
               <BR>
              <div style="text-align: center; ">
                <button type="button" class="theme-button btn" name="submit"  (click)="submitPreparationHD()" [disabled]="disablepharnacy">Submit</button>
                <button type="button" class="theme-button btn" name="Delete" (click)=" mesgDelete()"  [disabled]="disablepharnacy">Delete</button>
                <button type="button" class="theme-button btn" name="New"    (click)="NewData()">New</button>
                <button type="button" class="theme-button btn" name="print"  (click)="ReportPreparation()">Print</button>
                <button type="button" class="theme-button btn" name="calc"   (click)="OpenCalc()">Calculator</button>
                <button type="button" class="theme-button btn" name="Back">Home</button>
             </div>
            </div>
          </form>
        </div>

        <div class="registerimg" >

          <div class="styled-input">
            <BR>
            <!--************* Table for Previous transactions  ***********-->
            <label style="width: 300px;background-color: rgb(102, 102, 111);color: white; font-weight: bold;font-size: larger;text-align: center;height: 30px;padding-top: 1%;">Pervious Prepartion Orders</label>
            <table style="width: 300px;">
              <thead>
                <tr>
                  <th style="background-color:  rgb(102, 102, 111);color: white;width: 33%;text-align: center;">Visit Date</th>
                  <th style="background-color:  rgb(102, 102, 111);color: white;width: 33%;text-align: center;">P.O. No</th>
                  <th style="background-color:  rgb(102, 102, 111);color: white;width: 33%;text-align: center;">Select</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let sup of prevPOList; let i = index" style="height: 50%;">
                  <td data-column="Patient Name" style="height: 50%;">{{sup.docDate}}</td>
                  <td data-column="Patient Name" style="height: 40%;">{{sup.docNumber}}</td>
                  <button name="printpreviousrug3" placeholder="0" style="width: 100%;height: 37px;" required (click)="PreviousReportPreparation(sup)">Select</button>
                </tr>
              </tbody>
            </table>
            <BR>
            <BR>
          </div>
          <BR>
            <section style="top: 350px;overflow-y: scroll;height: 680px;">

                <div class="styled-input">
                  <div class="styled-input">
                    <label style="width: 690px;background-color: rgb(102, 102, 111);color: white; font-weight: bold;font-size: larger;text-align: center;height: 30px;padding-top: 1%;">Doctor Requests</label>
                    <table style="left: 50px;width: 690px;table-layout: fixed;">
                      <tr>
                        <th style="width: 35%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Regimen</th>
                        <th style="width: 7%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">No. of Cycle</th>
                        <th style="width: 5%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Day</th>
                        <!-- <th style="width: 15%;background-color:  rgb(102, 102, 111);color: white;">Start Date</th> -->
                        <th style="width: 12%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Dose</th>
                        <th style="width: 7%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Modif. Dose %</th>
                        <th style="width: 20%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Notes</th>
                      </tr>
                      <tr *ngFor="let item of cancertreatmentList; let i = index" style="font-size: {{wk_fontsize}};text-align: left;height: 50%;">
                        <td><label style="font-weight: bold;color: rgb(29, 0, 95);"  [hidden]="hiddenhead" ><u>{{item.trdate}} {{item.username}}</u></label><br>{{item.trkind}} </td>
                        <td>{{item.trcycleno}} </td>
                        <td>{{item.trdayscycle}} </td>
                        <!-- <td>{{item.trstartdate}} </td> -->
                        <td>{{item.trdose}} {{item.trunit}} </td>

                        <td>{{item.trdosemod}}% </td>
                        <td>

                          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                              <label>{{item.trnotes}}</label>
                          </div>
                        </td>

                      </tr>
                    </table>
                  </div>
                  <div style="text-align: center; ">
                    <a href="DoctorObservationTab" style="cursor: grab;">

                    <button type="button" class="theme-button btn" name="submit"  style="width: 690px;" (click)="DoctorObservation()" >Physician Assessment (Tab)</button>
                  </a>
                  </div>
                </div>

            </section>

        </div>

      </div>
    </div>
  </section>
</div>
